export default __webpack_public_path__ + "static/media/Iconly-Light-Document.90d65867.svg";